// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter_container__6A+To","content":"ModalFooter_content__bwT2Y"};